import { User } from './User.model';

export class TargetsByUserByCompanyByDateRangeResponse {
    users: User[];

    constructor(targetsByUserByCompanyByDateRange: Array<User>) {
        this.users = targetsByUserByCompanyByDateRange;
    }
}
